export const questionListProd = [
  {
    id: '1c40013a8fe0081dce327b277a64070d',
    text: `What is the role of protein in our diet?`,
  },
  {
    id: 'a9bcf0745c9eb06d2fb38a55d7c221b2',
    text: `What is the difference between emigrants and immigrants?`,
  },
  {
    id: 'bd37c348515c6857edf90a8f0847bf80',
    text: `What is meant by life expectancy?`,
  },
  {
    id: '1e6f0d42fd7e571b7a59db0eb229ca15',
    text: `Discuss why people moved from one part of the subcontinent to the other in ancient times.`,
  },
  {
    id: '01552084a68e257ca4e247848cc82c49',
    text: `Why were battles fought in the ancient vedic times?`,
  },
  {
    id: 'cec7aa8d352f4d677987e8bb317e6146',
    text: `Which material would you choose to make wires in an electric circuit, cotton or some metal? Why?`,
  },
  {
    id: '03c58ef34d2c21f09b7a805b4b137f62',
    text: `List all the characteristics of a biosphere reserve.`,
  },
  {
    id: '8d6182348d408779a018fca4d2cbd094',
    text: `What are some of the key consumer rights protected under COPRA?`,
  },
  {
    id: 'ed161aafbc0f223971ee8f36be30e714',
    text: `What do Adivasis lose when they are displaced from their lands?`,
  },
  {
    id: '425a1d9e297cb8b82a7c6f3645167493',
    text: `Why is human resources considered the ultimate resource? In what terms are they similar to natural resources?`,
  },
  {
    id: '9db03ad8685fa40db4ed0b94e5c8f295',
    text: `Why is consumer education important and how does it empower consumers?`,
  },
  {
    id: '1873647bf68cf71f75eecedbb8df7713',
    text: `What is the fair expectation of democracy in terms of creating a harmonious social life?`,
  },
  {
    id: '81f4626280e9c1185f3bdc33a262ce07',
    text: `How is the human voice produced?`,
  },
  {
    id: 'ac6d927882f5c6976c900cc690f8d8b8',
    text: `What are soluble and insoluble substances?,Give an example of a solid, a liquid and a gas that is soluble in water.`,
  },
  {
    id: '1a81755c0078b2931b17a45d620a1cad',
    text: `Which two metals do jewellers use to electroplate less expensive metals?`,
  },
  {
    id: '7098ad648f5ba0b1e16deb135348e874',
    text: `Explain how common salt is obtained from sea water.`,
  },
  {
    id: 'f16fb8eedc55f23006287c09f7afb843',
    text: `How do acidic and basic substances taste?`,
  },
  {
    id: '47285a5325e89a71f02df7078ffd0e19',
    text: `What is atmosphere?,Which cylinder do mountaineers carry when climbing high mountains?`,
  },
  {
    id: '9ed1c03f58254fd195d3d1cd5f3fa5f2',
    text: `Name the technique used for separating pieces of dirt and stones from rice.`,
  },
  {
    id: '2dbfe2ce04d83d419c512c2842a7f7b9',
    text: `Discuss the shift towards settled cultivation by tribal groups and its impact on their society.`,
  },
  {
    id: 'b4bf9d09e7bae5f588825d716765147b',
    text: `Define atmospheric pressure. Where does it come from?`,
  },
  {
    id: 'b53ef0d67c1a81662e5c46fd78e34a91',
    text: `How do government policies influence the cultivation of major crops?`,
  },
  {
    id: '689e6a4949a1ed9264fa74be9ecdf77a',
    text: `What are the challenges in using length of handspan or length of foot to measure lengths of different objects? Explain in brief.`,
  },
  {
    id: '5320d756bd6fed342391bd04a4e8b9e6',
    text: `Where is the last remaining habitat of the Asiatic lion in India?`,
  },
  {
    id: '7b034af7d579043e229dd8144956ab56',
    text: `Describe how Adivasis have been forced to abandon their lands for different reasons.`,
  },
  {
    id: 'e13e69f9dec218a04a6f92e56548d2b9',
    text: `List the three stages of the practices involved in farming.`,
  },
  {
    id: 'd048127712907a29abd4c173da827af8',
    text: `How is the condition of large farmers different from the condition of small farmers?`,
  },
  {
    id: 'e10c86475f4a2593d16876a7ee7261d7',
    text: `Is democracy a guarantee of economic development? Why?`,
  },
  {
    id: '250fb8a183ebf00d06aa7149d9423d81',
    text: `What do you understand by a secular state?`,
  },
  {
    id: '57b3272a0102cee6a3aba28a9da802cd',
    text: `Why do a large number of people from villages come to cities every year?`,
  },
  {
    id: '5291c29ceec1e57c224fa371c5741a46',
    text: `What do you understand by discrimination? Discuss some common forms of discrimination.`,
  },
  {
    id: '28af2be07f576d832fc2fa304aeb9917',
    text: `Why are small farmers in India more likely to get caught in debt?`,
  },
  {
    id: '332fe1036e74af77600e69dda7ce521c',
    text: `How are urban areas different from villages?`,
  },
  {
    id: 'ab173daa5084feff0f7a6fc582d7d2b0',
    text: `Describe three medicinal plants found in India and their uses.`,
  },
  {
    id: '19aca65142ef3bfac285cfbf1d5a07b4',
    text: `Assess the impact of industrial pollution and environmental degradation in India.`,
  },
  {
    id: 'cb4ab34733f41bb569dc1cbac8e18834',
    text: `Discuss the wild life diversity of India in detail.`,
  },
  {
    id: '58b55a2478667c2ea556a59956cc90a7',
    text: `Highlight the impact of the National Waterways Project on India's transport infrastructure.`,
  },
  {
    id: 'f98bc29fabcc6fbf10def5357518d63c',
    text: `Explain the importance of transparency as an outcome of democracy.`,
  },
  {
    id: '42fa9712094874cb98aefb71a9d8a96f',
    text: `What is the role of government in public facilities?`,
  },
  {
    id: '7ef25a2a102a111d9038e389f68da9e5',
    text: `Describe any four uses of magnets in everyday life.`,
  },
  {
    id: '86ce7fdde23b3151b6993e7f1a8ae2ac',
    text: `Describe in detail the different ways of finding out about the past.`,
  },
  {
    id: '1a1956e409fa75e30dac1c9c0b138bb3',
    text: `Describe the conditions under which:,1) Two magnets attract each other,2) Two magnets repel each other`,
  },
  {
    id: 'd2f0e0e1f62cb078eb04c24dd5addd70',
    text: `Name the conditions caused by the deficiency of insulin and thyroxine.`,
  },
  {
    id: 'a7e34546324ca4aee335a7c2f823d25d',
    text: `Name the structure through which air travels from the nasal cavity to the lungs.`,
  },
  {
    id: '92adeae5ec8bd747904d108971c8aa08',
    text: `Define magnetic and non-magnetic materials.`,
  },
  {
    id: 'f34844bb8d7e8b25cdd7a59b9baa0a09',
    text: `Why is the iron and steel industry considered a basic industry in India?`,
  },
  {
    id: '3d7d62e46cd0b9f0fcbf053e809f9589',
    text: `Evaluate the gap between expectations and the realities of democracy.`,
  },
  {
    id: 'd6c13b5a95dbc9483a542e80f4214e10',
    text: `What are the advantages of waterways over other modes of transport?`,
  },
  {
    id: 'cb164ae4007def7019e171b082e24e5e',
    text: `Which gas dissolves in water and helps the plants and animals survive?`,
  },
  {
    id: 'eab5eb01697b77b362c2dbb192353acf',
    text: `What is the commercial unit of electrical energy?`,
  },
  {
    id: '81ff2a891c73492bf004a6fe73d0c5df',
    text: `What are soluble substances?`,
  },
  {
    id: '9e7b9b06b7913dc7db4fff55c84c5b5a',
    text: `Describe transparent, translucent and opaque materials.`,
  },
  {
    id: 'ad7fdca904cdc13b2277bf1e4dcc7064',
    text: `List the necessary conditions for rusting.`,
  },
  {
    id: '79fb37ddc54d6a7b989d7015abb4c26d',
    text: `What is the composition of air?`,
  },
  { id: 'c01f9796153adcb260ae14529242ec26', text: `What is winnowing?` },
  {
    id: '902e48080ed67138f9e8b2f03adeff26',
    text: `List and briefly explain each step in separating a mixture of salt, sand, and water.`,
  },
  {
    id: '2940e4f45f0e3c16a36145316f3cd916',
    text: `Answer the following:,1) What are some adverse effects of noise pollution on our health? List any four.,2) What measures can we take to reduce the noise pollution around us? List any four.`,
  },
  {
    id: '5cfb9ef7b3384278d68501c3eb8a785d',
    text: `Describe in brief how would you demonstrate that the seven colours (VIBGYOR) when combined, form white colour`,
  },
  {
    id: '18e020dbb910b849255ff645a6c2ff24',
    text: `What is an AI Integrated approach in teaching and learning?`,
  },
  {
    id: '9cf898000f26f832facb1f49b87250c9',
    text: `Give scientific reason: we always place the pointed end of a nail, and not the flat one, in contact with a wooden plank when pushing it in.`,
  },
  {
    id: 'cca76fa450f48a56bb786a8e2fc92991',
    text: `Define inflammable substances and give any two examples.`,
  },
  {
    id: 'fc68d7840f5e398d4c6159904afac734',
    text: `List at least four precautions to be observed while using a clinical thermometer.`,
  },
  {
    id: 'a36a378e0fe1affcd9de74bb2e26a6c7',
    text: `What is the average normal temperature of human body?`,
  },
  {
    id: '72457bf9897e3b17dfa1583f49c6f895',
    text: `List four different means of transportation people use in modern times?`,
  },
  {
    id: '871831f62e6efb27e6124d84a7261703',
    text: `What do we use electricity for? List any two applications.`,
  },
  {
    id: '2f7f6d87c2bd42385c1e68a8f261673a',
    text: `What is the budget? What is announced in the budget?`,
  },
  {
    id: 'f256b68091d840c6c23b1fb9ef07df20',
    text: `Why is India fortunate in terms of human resources?`,
  },
  {
    id: 'c379a64fee53604fafedae5b616b5783',
    text: `What do you understand by the term Scheduled Tribes?`,
  },
  {
    id: '18fb9d96d6d408a42ff3882544b6536a',
    text: `Which part of plants is referred to as the food factory? Name the green pigment present in it.`,
  },
  {
    id: 'ccd37bd0dc52e34c03ccbfd6a5ad9f00',
    text: `Elaborate on the importance of conserving energy resources and propose sustainable practices and technologies for efficient energy use in India.`,
  },
  {
    id: '30bbe9dedcf9a88f392072747f87b8b2',
    text: `State the law of conservation of energy.`,
  },
  {
    id: '21f7388ff5d2f478fc866a8646dbd9b7',
    text: `What are agro based industries? Give an example.`,
  },
  { id: 'ace6f0ea526a8f101cd3fa7510109ba2', text: `Define dispersion.` },
  {
    id: 'fc51484e75deb5a0dbc0abbafe366a91',
    text: `How does the Indian Constitution ensure equality among citizens in India?`,
  },
  {
    id: 'f43468ffba7320776a69ca10fd679d51',
    text: `What are the two uses of natural gas?`,
  },
  {
    id: '5f189cd23d36f3b9947e0a5ffaa28370',
    text: `Where does the name "Rajputs" come from?`,
  },
  {
    id: '2066bb87449ae5fcc57f1dd5af873293',
    text: `How did our country get the name India?`,
  },
  {
    id: '203c72336dc48250d3a44effb22be292',
    text: `State four functions of the tongue.`,
  },
  {
    id: '3a8de683521aab9035a3c1653e602aa0',
    text: `What colour change would you observe when a few drops of iodine solution are put on a raw potato?`,
  },
  {
    id: '070ee33ddd41fa6f5dd8fdf5c244bcbf',
    text: `What is a magnetic compass and how is it used to find directions?`,
  },
  {
    id: '5b731e9ab3e597b7b364a3dd17c9e045',
    text: `How does force arise between two objects?`,
  },
  {
    id: 'a5c7668ce13dd7fe26c63d4bc2e00a31',
    text: `Who is known as the Father of the Indian Constitution?`,
  },
  {
    id: 'b2f5ea2d5ebdc60c0fe0340a3f70ec46',
    text: `Name the process of filtering blood periodically through an artificial kidney.`,
  },
  {
    id: '1b91a53d7b3a98e38af1e7002eb758ef',
    text: `What is meant by natural vegetation?`,
  },
  {
    id: '22d3353895a21eeea84a5a66a904f008',
    text: `List two examples from everyday life where friction produces heat.`,
  },
  {
    id: 'eff3ae3b3788d7ac61d7d5b54daa1c99',
    text: `Identify two major challenges faced by the Indian Railways.`,
  },
  {
    id: '42bac3866cfb1e14421a9a010e9bf562',
    text: `What does food security mean in the context of India?`,
  },
  {
    id: '50e0b960148111ebe1cf8571fa4f9159',
    text: `What are natural resources?`,
  },
  {
    id: 'a0b1d48f9cb24372cc6e0e750d8724e6',
    text: `How is petroleum formed in nature?`,
  },
  {
    id: '3d9bb8eef39f903ecd8624d09cba5653',
    text: `Why should we conserve exhaustible natural resources?`,
  },
  {
    id: 'f009bc93a9b863031e3f81d191858adf',
    text: `Define evaporation and describe in detail the four factors that affect the rate of evaporation.`,
  },
  {
    id: '2d9fb9c65d93f1720ff27cf698f7e52a',
    text: `What leads to suffocation when something burns in a closed room?`,
  },
  {
    id: 'f3d91bbd64301d9b6399fccb857e6e6a',
    text: `How does a sound travel in a medium? Explain in brief.`,
  },
  {
    id: '91b62ddfc8d41f36583ddef7363c2e02',
    text: `Give two properties of air.`,
  },
  {
    id: '65095d18431bd9be75ea059a08d15ed2',
    text: `What are the five states that account for about half of India’s population?`,
  },
  {
    id: '0a2dd065a2643c43d773ad99843cd394',
    text: `Define translucent materials.`,
  },
  {
    id: '6a5b75ecd4744e0df0fc573c57bd0f2f',
    text: `What is the importance of clean water? How do the Indian constitution and judiciary recognise the right to water?`,
  },
  {
    id: '8084c05ffa52d3cd4205a0696de05999',
    text: `Imagine two teams playing tug of war. When does the rope stay still during a tug of war?`,
  },
  {
    id: 'fa31133dcd00889c32d654a2e2f7929e',
    text: `Give scientific reason: the ceilings of a concert hall are curved.`,
  },
  {
    id: 'dab0a3464efaab991474d303f3100b94',
    text: `When is an object said to be slow or fast? Justify your answer with the help of examples.`,
  },
];
